// SAVE-CANON (phone) — the shared Discard confirm for NEW-record editors (canon: new record =
// explicit Save + dirty guard; a back/scrim tap never silently discards). One dynamically built
// overlay in the house destructive style (.tk-cf, same as the delete confirms), promise-based so
// callers just `if (await confirmDiscard("this task")) close();`.
export function confirmDiscard(what: string): Promise<boolean> {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    host.className = "tk-cf open";
    host.innerHTML =
      `<div class="tk-cf-scrim"></div>` +
      `<div class="tk-cf-box">` +
      `<div class="tk-cf-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg></div>` +
      `<h4>Discard ${escText(what)}?</h4>` +
      `<p>What you typed won’t be saved. This can’t be undone.</p>` +
      `<button class="tk-cf-del" type="button">Discard</button>` +
      `<button class="tk-cf-keep" type="button">Keep editing</button>` +
      `</div>`;
    const done = (v: boolean) => { host.remove(); resolve(v); };
    host.querySelector(".tk-cf-del")?.addEventListener("click", () => done(true));
    host.querySelector(".tk-cf-keep")?.addEventListener("click", () => done(false));
    host.querySelector(".tk-cf-scrim")?.addEventListener("click", () => done(false)); // scrim = safe default
    document.body.appendChild(host);
  });
}
const escText = (s: string): string => s.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]!));
